module.exports = __webpack_public_path__ + "assets/3559c0ad9288b57236c1a0742232a7e8.mp3";